import Vue from 'vue'
import './plugins/vuetify'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Vuetify from 'vuetify'
import Vuelidate from 'vuelidate'
import VeeValidate, { Validator } from 'vee-validate'
import i18n from './i18n'
import en from '@/locales/en.json'
import ja from '@/locales/ja.json'
import zhHans from '@/locales/zhHans.json'
import zhHant from '@/locales/zhHant.json'
import moment from 'moment-timezone'
import '@mdi/font/css/materialdesignicons.css'

import money from 'v-money'
import VueAnalytics from 'vue-analytics'

// index.js or main.js
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

// main.styl
//@import '~vuetify/src/stylus/main' // Ensure you are using stylus-loader

// QRCode 20240326 kium
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent);

// Cookie 20240415
import VueCookies from "vue-cookies";
// 쿠키를 사용한다
Vue.use(VueCookies);
// 쿠키의 만료일은 1일이다(글로벌 세팅)
Vue.$cookies.config("1d");

moment.tz.setDefault('Asia/Tokyo')

Vue.use(Vuelidate) // TODO vuelidateは使用する？
Vue.use(Vuetify)
Vue.use(money, {
  precision: 4
})
Vue.use(Vuetify, {
  iconfont: 'mdi' // 'md' || 'mdi' || 'fa' || 'fa4'
})
Vue.use(VueAnalytics, {
  id: 'UA-163290206-1',
  router
})

// vee-validateのi18n

Validator.localize('ja', ja) // デフォルトはen
Validator.localize('en', en) // デフォルトはen
Validator.localize('zhHans', zhHans) // デフォルトはen
Validator.localize('zhHant', zhHant) // デフォルトはen
Vue.use(
  VeeValidate,
  // オプションでi18nを指定する
  {
    i18n,
    i18nRootKey: 'validations',
    dictionary: { ja, en, zhHans, zhHant }
  }
)

//Validator.localize('en')

// import titleMixin from './util/title'
// Vue.mixin(titleMixin)

Vue.config.productionTip = false

// Automatic Global Registration
const requireComponent = require.context(
  './components',
  false,
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
  )

  Vue.component(componentName, componentConfig.default || componentConfig)

})

new Vue({
  router,
  store,
  i18n,
  moment,
  render: h => h(App)
}).$mount('#app')
